export const CALL_REQUEST_USERS = "CALL_REQUEST_USERS";

// ─── Activity Logs ───────────────────────────────────────────────
export const FETCH_ACTIVITY_LOGS_REQUEST = "FETCH_ACTIVITY_LOGS_REQUEST";
export const FETCH_ACTIVITY_LOGS_SUCCESS = "FETCH_ACTIVITY_LOGS_SUCCESS";
export const FETCH_ACTIVITY_LOGS_FAILURE = "FETCH_ACTIVITY_LOGS_FAILURE";

// ─── News Category ───────────────────────────────────────────────
export const NEWS_CATEGORY_REQUEST = "NEWS_CATEGORY_REQUEST";
export const NEWS_CATEGORY_FAILURE = "NEWS_CATEGORY_FAILURE";

export const FETCH_NEWS_CATEGORIES_SUCCESS = "FETCH_NEWS_CATEGORIES_SUCCESS";
export const CREATE_NEWS_CATEGORY_SUCCESS = "CREATE_NEWS_CATEGORY_SUCCESS";
export const UPDATE_NEWS_CATEGORY_SUCCESS = "UPDATE_NEWS_CATEGORY_SUCCESS";
export const DELETE_NEWS_CATEGORY_SUCCESS = "DELETE_NEWS_CATEGORY_SUCCESS";
export const GET_NEWS_CATEGORY_SUCCESS = "GET_NEWS_CATEGORY_SUCCESS";

// ─── News Article ────────────────────────────────────────────────
export const NEWS_ARTICLE_REQUEST = "NEWS_ARTICLE_REQUEST";
export const NEWS_ARTICLE_FAILURE = "NEWS_ARTICLE_FAILURE";

export const FETCH_NEWS_ARTICLES_SUCCESS = "FETCH_NEWS_ARTICLES_SUCCESS";
export const CREATE_NEWS_ARTICLE_SUCCESS = "CREATE_NEWS_ARTICLE_SUCCESS";
export const UPDATE_NEWS_ARTICLE_SUCCESS = "UPDATE_NEWS_ARTICLE_SUCCESS";
export const DELETE_NEWS_ARTICLE_SUCCESS = "DELETE_NEWS_ARTICLE_SUCCESS";
export const GET_NEWS_ARTICLE_SUCCESS = "GET_NEWS_ARTICLE_SUCCESS";

// ─── User Management ─────────────────────────────────────────────
export const USER_REQUEST = "USER_REQUEST";
export const USER_FAILURE = "USER_FAILURE";

export const FETCH_USERS_SUCCESS = "FETCH_USERS_SUCCESS";
export const FETCH_ELMS_FOR_FEATURE_SUCCESS = "FETCH_ELMS_FOR_FEATURE_SUCCESS";
export const FETCH_ELMS_BY_GROUPS_SUCCESS = "FETCH_ELMS_BY_GROUPS_SUCCESS";
export const APPEND_ELMS_FOR_FEATURE_SUCCESS =
  "APPEND_ELMS_FOR_FEATURE_SUCCESS";
export const CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS";
export const GET_USER_SUCCESS = "GET_USER_SUCCESS";
export const UPDATE_STATUS_USER_SUCCESS = "UPDATE_STATUS_USER_SUCCESS";
export const FETCH_SUPERIORS_SUCCESS = "FETCH_SUPERIORS_SUCCESS";

// ─── Authentication ──────────────────────────────────────────────
export const AUTH_SET_USER = "AUTH_SET_USER";
export const AUTH_LOGOUT = "AUTH_LOGOUT";

// ─── Ward ────────────────────────────────────────────────
export const WARD_REQUEST = "WARD_REQUEST";
export const WARD_FAILURE = "WARD_FAILURE";

export const FETCH_WARDS_SUCCESS = "FETCH_WARDS_SUCCESS";
export const CREATE_WARD_SUCCESS = "CREATE_WARD_SUCCESS";
export const UPDATE_WARD_SUCCESS = "UPDATE_WARD_SUCCESS";
export const DELETE_WARD_SUCCESS = "DELETE_WARD_SUCCESS";
export const GET_WARD_SUCCESS = "GET_WARD_SUCCESS";

// ─── Public Service Links ────────────────────────────────────────────────
export const PUBLIC_SERVICE_LINKS_REQUEST = "PUBLIC_SERVICE_LINKS_REQUEST";
export const PUBLIC_SERVICE_LINKS_FAILURE = "PUBLIC_SERVICE_LINKS_FAILURE";

export const FETCH_PUBLIC_SERVICE_LINKS_SUCCESS =
  "FETCH_PUBLIC_SERVICE_LINKS_SUCCESS";
export const SET_FEATURED_PUBLIC_SERVICE_LINKS =
  "SET_FEATURED_PUBLIC_SERVICE_LINKS";
export const SET_NORMAL_PUBLIC_SERVICE_LINKS =
  "SET_NORMAL_PUBLIC_SERVICE_LINKS";
export const CREATE_PUBLIC_SERVICE_LINKS_SUCCESS =
  "CREATE_PUBLIC_SERVICE_LINKS_SUCCESS";
export const UPDATE_PUBLIC_SERVICE_LINKS_SUCCESS =
  "UPDATE_PUBLIC_SERVICE_LINKS_SUCCESS";
export const DELETE_PUBLIC_SERVICE_LINKS_SUCCESS =
  "DELETE_PUBLIC_SERVICE_LINKS_SUCCESS";
export const GET_PUBLIC_SERVICE_LINKS_SUCCESS =
  "GET_PUBLIC_SERVICE_LINKS_SUCCESS";

// ─── Public Service Categories ───────────────────────────────────
export const PUBLIC_SERVICE_CATEGORY_REQUEST =
  "PUBLIC_SERVICE_CATEGORY_REQUEST";
export const PUBLIC_SERVICE_CATEGORY_MUTATION_REQUEST =
  "PUBLIC_SERVICE_CATEGORY_MUTATION_REQUEST";
export const PUBLIC_SERVICE_CATEGORY_FAILURE =
  "PUBLIC_SERVICE_CATEGORY_FAILURE";
export const FETCH_PUBLIC_SERVICE_CATEGORIES_SUCCESS =
  "FETCH_PUBLIC_SERVICE_CATEGORIES_SUCCESS";
export const CREATE_PUBLIC_SERVICE_CATEGORY_SUCCESS =
  "CREATE_PUBLIC_SERVICE_CATEGORY_SUCCESS";
export const UPDATE_PUBLIC_SERVICE_CATEGORY_SUCCESS =
  "UPDATE_PUBLIC_SERVICE_CATEGORY_SUCCESS";
export const DELETE_PUBLIC_SERVICE_CATEGORY_SUCCESS =
  "DELETE_PUBLIC_SERVICE_CATEGORY_SUCCESS";

// ─── Area Officers ────────────────────────────────────────────────
export const AREAOFFICERS_REQUEST = "AREAOFFICERS_REQUEST";
export const AREAOFFICERS_FAILURE = "AREAOFFICERS_FAILURE";

export const FETCH_AREAOFFICERS_SUCCESS = "FETCH_AREAOFFICERS_SUCCESS";
export const CREATE_AREAOFFICERS_SUCCESS = "CREATE_AREAOFFICERS_SUCCESS";
export const UPDATE_AREAOFFICERS_SUCCESS = "UPDATE_AREAOFFICERS_SUCCESS";
export const DELETE_AREAOFFICERS_SUCCESS = "DELETE_AREAOFFICERS_SUCCESS";
export const GET_AREAOFFICERS_SUCCESS = "GET_AREAOFFICERS_SUCCESS";

// ─── Appointment ────────────────────────────────────────────────
export const APPOINTMENT_REQUEST = "APPOINTMENT_REQUEST";
export const APPOINTMENT_FAILURE = "APPOINTMENT_FAILURE";

export const FETCH_APPOINTMENT_SUCCESS = "FETCH_APPOINTMENT_SUCCESS";
export const CREATE_APPOINTMENT_SUCCESS = "CREATE_APPOINTMENT_SUCCESS";
export const UPDATE_APPOINTMENT_SUCCESS = "UPDATE_APPOINTMENT_SUCCESS";
export const DELETE_APPOINTMENT_SUCCESS = "DELETE_APPOINTMENT_SUCCESS";
export const GET_APPOINTMENT_SUCCESS = "GET_APPOINTMENT_SUCCESS";
export const FETCH_RECEPTION_SCHEDULE_SUCCESS =
  "FETCH_RECEPTION_SCHEDULE_SUCCESS";
export const CREATE_RECEPTION_LOCATION_SUCCESS =
  "CREATE_RECEPTION_LOCATION_SUCCESS";
export const UPDATE_RECEPTION_LOCATION_SUCCESS =
  "UPDATE_RECEPTION_LOCATION_SUCCESS";
export const DELETE_RECEPTION_LOCATION_SUCCESS =
  "DELETE_RECEPTION_LOCATION_SUCCESS";
export const CREATE_RECEPTION_SCHEDULE_SUCCESS =
  "CREATE_RECEPTION_SCHEDULE_SUCCESS";
export const UPDATE_RECEPTION_SCHEDULE_SUCCESS =
  "UPDATE_RECEPTION_SCHEDULE_SUCCESS";
export const DELETE_RECEPTION_SCHEDULE_SUCCESS =
  "DELETE_RECEPTION_SCHEDULE_SUCCESS";
export const UPDATE_RECEPTION_DAILY_SUCCESS = "UPDATE_RECEPTION_DAILY_SUCCESS";

// ─── Feedbacks ────────────────────────────────────────────────
export const FEEDBACKS_REQUEST = "FEEDBACKS_REQUEST";
export const FEEDBACKS_FAILURE = "FEEDBACKS_FAILURE";

export const FETCH_FEEDBACKS_SUCCESS = "FETCH_FEEDBACKS_SUCCESS";
export const CREATE_FEEDBACKS_SUCCESS = "CREATE_FEEDBACKS_SUCCESS";
export const UPDATE_FEEDBACKS_SUCCESS = "UPDATE_FEEDBACKS_SUCCESS";
export const DELETE_FEEDBACKS_SUCCESS = "DELETE_FEEDBACKS_SUCCESS";
export const GET_FEEDBACKS_SUCCESS = "GET_FEEDBACKS_SUCCESS";
export const FETCH_ESCALATIONS_SUCCESS = "FETCH_ESCALATIONS_SUCCESS";
export const REALTIME_FEEDBACK_RECEIVED = "REALTIME_FEEDBACK_RECEIVED";

// ─── Permissions ────────────────────────────────────────────────
export const PERMISSIONS_REQUEST = "PERMISSIONS_REQUEST";
export const PERMISSIONS_FAILURE = "PERMISSIONS_FAILURE";

export const FETCH_PERMISSIONS_SUCCESS = "FETCH_PERMISSIONS_SUCCESS";
export const CREATE_PERMISSIONS_SUCCESS = "CREATE_PERMISSIONS_SUCCESS";
export const UPDATE_PERMISSIONS_SUCCESS = "UPDATE_PERMISSIONS_SUCCESS";
export const DELETE_PERMISSIONS_SUCCESS = "DELETE_PERMISSIONS_SUCCESS";
export const GET_PERMISSIONS_SUCCESS = "GET_PERMISSIONS_SUCCESS";

// ─── Roles ────────────────────────────────────────────────
export const ROLES_REQUEST = "ROLES_REQUEST";
export const ROLES_FAILURE = "ROLES_FAILURE";

export const FETCH_ROLES_SUCCESS = "FETCH_ROLES_SUCCESS";
export const CREATE_ROLES_SUCCESS = "CREATE_ROLES_SUCCESS";
export const UPDATE_ROLES_SUCCESS = "UPDATE_ROLES_SUCCESS";
export const DELETE_ROLES_SUCCESS = "DELETE_ROLES_SUCCESS";
export const GET_ROLES_SUCCESS = "GET_ROLES_SUCCESS";

// ─── AI Conversations ──────────────────────────────────────────
export const AI_CONVERSATION_REQUEST = "AI_CONVERSATION_REQUEST";
export const AI_CONVERSATION_FAILURE = "AI_CONVERSATION_FAILURE";

export const FETCH_AI_CONVERSATIONS_SUCCESS = "FETCH_AI_CONVERSATIONS_SUCCESS";
export const GET_AI_CONVERSATION_SUCCESS = "GET_AI_CONVERSATION_SUCCESS";
export const SEND_AI_MESSAGE_SUCCESS = "SEND_AI_MESSAGE_SUCCESS";
export const SEND_AI_MESSAGE_REQUEST = "SEND_AI_MESSAGE_REQUEST";
export const SEND_AI_MESSAGE_FAILURE = "SEND_AI_MESSAGE_FAILURE";
export const FETCH_AI_USAGE_STATS_SUCCESS = "FETCH_AI_USAGE_STATS_SUCCESS";
export const FETCH_AI_USAGE_STATS_CHARTS_SUCCESS = "FETCH_AI_USAGE_STATS_CHARTS_SUCCESS";


// ─── Areas ───────────────────────────────────────────────────
export const AREAS_REQUEST = "AREAS_REQUEST";
export const AREAS_FAILURE = "AREAS_FAILURE";

export const FETCH_AREAS_SUCCESS = "FETCH_AREAS_SUCCESS";
export const CREATE_AREAS_SUCCESS = "CREATE_AREAS_SUCCESS";
export const UPDATE_AREAS_SUCCESS = "UPDATE_AREAS_SUCCESS";
export const DELETE_AREAS_SUCCESS = "DELETE_AREAS_SUCCESS";
export const GET_AREAS_SUCCESS = "GET_AREAS_SUCCESS";

// ─── Dashboard ───────────────────────────────────────────────
export const DASHBOARD_REQUEST = "DASHBOARD_REQUEST";
export const DASHBOARD_FAILURE = "DASHBOARD_FAILURE";

export const FETCH_COMMAND_CENTER_SUCCESS = "FETCH_COMMAND_CENTER_SUCCESS";
export const FETCH_DASHBOARD_SECTION_SUCCESS =
  "FETCH_DASHBOARD_SECTION_SUCCESS";
export const FETCH_DASHBOARD_STATS_SUCCESS = "FETCH_DASHBOARD_STATS_SUCCESS";
export const FETCH_RECENT_FEEDBACKS_SUCCESS = "FETCH_RECENT_FEEDBACKS_SUCCESS";
export const FETCH_RECENT_APPOINTMENTS_SUCCESS =
  "FETCH_RECENT_APPOINTMENTS_SUCCESS";

// ─── Priority Rules ───────────────────────────────────────────────
export const PRIORITY_RULES_REQUEST = "PRIORITY_RULES_REQUEST";
export const PRIORITY_RULES_FAILURE = "PRIORITY_RULES_FAILURE";

export const FETCH_PRIORITY_RULES_SUCCESS = "FETCH_PRIORITY_RULES_SUCCESS";
export const CREATE_PRIORITY_RULE_SUCCESS = "CREATE_PRIORITY_RULE_SUCCESS";
export const UPDATE_PRIORITY_RULE_SUCCESS = "UPDATE_PRIORITY_RULE_SUCCESS";
export const DELETE_PRIORITY_RULE_SUCCESS = "DELETE_PRIORITY_RULE_SUCCESS";
export const TOGGLE_PRIORITY_RULE_SUCCESS = "TOGGLE_PRIORITY_RULE_SUCCESS";

// ─── Escalation Settings ─────────────────────────────────────────
export const ESCALATION_SETTINGS_REQUEST = "ESCALATION_SETTINGS_REQUEST";
export const ESCALATION_SETTINGS_FAILURE = "ESCALATION_SETTINGS_FAILURE";

export const FETCH_ESCALATION_SETTINGS_SUCCESS =
  "FETCH_ESCALATION_SETTINGS_SUCCESS";
export const CREATE_ESCALATION_SETTING_SUCCESS =
  "CREATE_ESCALATION_SETTING_SUCCESS";
export const UPDATE_ESCALATION_SETTING_SUCCESS =
  "UPDATE_ESCALATION_SETTING_SUCCESS";
export const DELETE_ESCALATION_SETTING_SUCCESS =
  "DELETE_ESCALATION_SETTING_SUCCESS";

export const ESCALATION_ADD_RULE = "ESCALATION_ADD_RULE";
export const ESCALATION_UPDATE_RULE = "ESCALATION_UPDATE_RULE";
export const ESCALATION_DELETE_RULE = "ESCALATION_DELETE_RULE";

// ─── Category Settings ──────────────────────────────────────────
export const CATEGORY_SETTINGS_REQUEST = "CATEGORY_SETTINGS_REQUEST";
export const CATEGORY_SETTINGS_FAILURE = "CATEGORY_SETTINGS_FAILURE";

export const FETCH_CATEGORY_SETTINGS_SUCCESS =
  "FETCH_CATEGORY_SETTINGS_SUCCESS";
export const CREATE_CATEGORY_SETTING_SUCCESS =
  "CREATE_CATEGORY_SETTING_SUCCESS";
export const UPDATE_CATEGORY_SETTING_SUCCESS =
  "UPDATE_CATEGORY_SETTING_SUCCESS";
export const DELETE_CATEGORY_SETTING_SUCCESS =
  "DELETE_CATEGORY_SETTING_SUCCESS";

// ─── Feedback Cases (local state) ───────────────────────────────
export const FB_CASES_INIT = "FB_CASES_INIT";
export const FB_CASE_ACCEPT = "FB_CASE_ACCEPT";
export const FB_CASE_START_PROCESS = "FB_CASE_START_PROCESS";
export const FB_CASE_UPDATE_PROGRESS = "FB_CASE_UPDATE_PROGRESS";
export const FB_CASE_RESPOND = "FB_CASE_RESPOND";
export const FB_CASE_REASSIGN = "FB_CASE_REASSIGN";
export const FB_CASE_CHANGE_PRIORITY = "FB_CASE_CHANGE_PRIORITY";

// ─── Miniapp Accounts ───────────────────────────────────────────
export const MINIAPP_ACCOUNTS_REQUEST = "MINIAPP_ACCOUNTS_REQUEST";
export const MINIAPP_ACCOUNTS_FAILURE = "MINIAPP_ACCOUNTS_FAILURE";

export const FETCH_MINIAPP_ACCOUNTS_SUCCESS = "FETCH_MINIAPP_ACCOUNTS_SUCCESS";
export const FETCH_MINIAPP_ACCOUNT_AREAS_SUCCESS =
  "FETCH_MINIAPP_ACCOUNT_AREAS_SUCCESS";

export const CREATE_MINIAPP_ACCOUNT_SUCCESS = "CREATE_MINIAPP_ACCOUNT_SUCCESS";
export const UPDATE_MINIAPP_ACCOUNT_SUCCESS = "UPDATE_MINIAPP_ACCOUNT_SUCCESS";
export const DELETE_MINIAPP_ACCOUNT_SUCCESS = "DELETE_MINIAPP_ACCOUNT_SUCCESS";
export const GET_MINIAPP_ACCOUNT_SUCCESS = "GET_MINIAPP_ACCOUNT_SUCCESS";

// ─── Group Areas ────────────────────────────────────────────────
export const GROUP_AREA_REQUEST = "GROUP_AREA_REQUEST";
export const GROUP_AREA_FAILURE = "GROUP_AREA_FAILURE";

export const FETCH_GROUP_AREAS_SUCCESS = "FETCH_GROUP_AREAS_SUCCESS";
export const CREATE_GROUP_AREA_SUCCESS = "CREATE_GROUP_AREA_SUCCESS";
export const UPDATE_GROUP_AREA_SUCCESS = "UPDATE_GROUP_AREA_SUCCESS";
export const DELETE_GROUP_AREA_SUCCESS = "DELETE_GROUP_AREA_SUCCESS";
export const GET_GROUP_AREA_SUCCESS = "GET_GROUP_AREA_SUCCESS";

// ─── Notifications ───────────────────────────────────────────────
export const NOTIFICATIONS_REQUEST = "NOTIFICATIONS_REQUEST";
export const NOTIFICATIONS_FAILURE = "NOTIFICATIONS_FAILURE";
export const FETCH_NOTIFICATIONS_SUCCESS = "FETCH_NOTIFICATIONS_SUCCESS";
export const MARK_NOTIFICATION_READ = "MARK_NOTIFICATION_READ";
export const MARK_ALL_NOTIFICATIONS_READ = "MARK_ALL_NOTIFICATIONS_READ";
export const DELETE_NOTIFICATION = "DELETE_NOTIFICATION";
export const DELETE_ALL_NOTIFICATIONS = "DELETE_ALL_NOTIFICATIONS";
export const ADD_NOTIFICATION = "ADD_NOTIFICATION";
export const SET_NOTIFICATION_COUNTS = "SET_NOTIFICATION_COUNTS";

// ─── Task Managements ───────────────────────────────────────────
export const TASKS_REQUEST = "TASKS_REQUEST";
export const TASKS_FAILURE = "TASKS_FAILURE";
export const FETCH_TASKS_SUCCESS = "FETCH_TASKS_SUCCESS";
export const CREATE_TASK_SUCCESS = "CREATE_TASK_SUCCESS";
export const UPDATE_TASK_SUCCESS = "UPDATE_TASK_SUCCESS";
export const DELETE_TASK_SUCCESS = "DELETE_TASK_SUCCESS";
export const FETCH_TASK_STATISTICS_SUCCESS = "FETCH_TASK_STATISTICS_SUCCESS";

// ─── Task Management Categories ─────────────────────────────────
export const TASK_CATEGORY_REQUEST = "TASK_CATEGORY_REQUEST";
export const TASK_CATEGORY_MUTATION_REQUEST =
  "TASK_CATEGORY_MUTATION_REQUEST";
export const TASK_CATEGORY_FAILURE = "TASK_CATEGORY_FAILURE";
export const FETCH_TASK_CATEGORIES_SUCCESS = "FETCH_TASK_CATEGORIES_SUCCESS";
export const CREATE_TASK_CATEGORY_SUCCESS = "CREATE_TASK_CATEGORY_SUCCESS";
export const UPDATE_TASK_CATEGORY_SUCCESS = "UPDATE_TASK_CATEGORY_SUCCESS";
export const DELETE_TASK_CATEGORY_SUCCESS = "DELETE_TASK_CATEGORY_SUCCESS";

// ─── Broadcasts ──────────────────────────────────────────────────
export const BROADCAST_REQUEST = "BROADCAST_REQUEST";
export const BROADCAST_FAILURE = "BROADCAST_FAILURE";
export const FETCH_BROADCASTS_SUCCESS = "FETCH_BROADCASTS_SUCCESS";
export const GET_BROADCAST_SUCCESS = "GET_BROADCAST_SUCCESS";
export const CREATE_BROADCAST_SUCCESS = "CREATE_BROADCAST_SUCCESS";
export const UPDATE_BROADCAST_SUCCESS = "UPDATE_BROADCAST_SUCCESS";
export const DELETE_BROADCAST_SUCCESS = "DELETE_BROADCAST_SUCCESS";
export const FETCH_BROADCAST_CATEGORIES_SUCCESS =
  "FETCH_BROADCAST_CATEGORIES_SUCCESS";
export const ADD_BROADCAST_CATEGORY = "ADD_BROADCAST_CATEGORY";
export const UPDATE_BROADCAST_CATEGORY = "UPDATE_BROADCAST_CATEGORY";
export const REMOVE_BROADCAST_CATEGORY = "REMOVE_BROADCAST_CATEGORY";
export const FETCH_STATISTICS_BY_AREA_SUCCESS =
  "FETCH_STATISTICS_BY_AREA_SUCCESS";

// ─── House Number Rules ───────────────────────────────────────────
export const HOUSE_NUMBER_RULES_REQUEST = "HOUSE_NUMBER_RULES_REQUEST";
export const HOUSE_NUMBER_RULES_FAILURE = "HOUSE_NUMBER_RULES_FAILURE";
export const FETCH_HOUSE_NUMBER_RULES_SUCCESS =
  "FETCH_HOUSE_NUMBER_RULES_SUCCESS";
export const CREATE_HOUSE_NUMBER_RULE_SUCCESS =
  "CREATE_HOUSE_NUMBER_RULE_SUCCESS";
export const UPDATE_HOUSE_NUMBER_RULE_SUCCESS =
  "UPDATE_HOUSE_NUMBER_RULE_SUCCESS";
export const DELETE_HOUSE_NUMBER_RULE_SUCCESS =
  "DELETE_HOUSE_NUMBER_RULE_SUCCESS";
export const FETCH_HOUSE_NUMBER_RULES_APPEND =
  "FETCH_HOUSE_NUMBER_RULES_APPEND";
export const SET_SELECTED_TDP = "SET_SELECTED_TDP";

// ─── House Number TDP Areas ───────────────────────────────────────
export const FETCH_TDP_AREAS_REQUEST = "FETCH_TDP_AREAS_REQUEST";
export const FETCH_TDP_AREAS_SUCCESS = "FETCH_TDP_AREAS_SUCCESS";
export const FETCH_TDP_AREAS_FAILURE = "FETCH_TDP_AREAS_FAILURE";
export const FETCH_TDP_AREAS_APPEND = "FETCH_TDP_AREAS_APPEND";
// ─── Feedback By Officer ────────────────────────────────────────────────
export const FEEDBACK_BY_OFFICER_REQUEST = "FEEDBACK_BY_OFFICER_REQUEST";
export const FEEDBACK_BY_OFFICER_FAILURE = "FEEDBACK_BY_OFFICER_FAILURE";
export const FETCH_FEEDBACK_BY_OFFICER_SUCCESS = "FETCH_FEEDBACK_BY_OFFICER_SUCCESS";
